import React from "react";
import * as S from "./styles";

const Button = ({
  action,
  height,
  width,
  label,
  color,
  textColor,
  fontSize,
  border,
  borderRadius,
  borderColor,
  weight,
  padding,
  hoverColor,
  hoverTextColor,
  selected,
  dataElement
}) => {
  return (
    <S.Button
      onClick={() => action()}
      styleButton={{
        height,
        width,
        color,
        textColor,
        fontSize,
        border,
        borderRadius,
        borderColor,
        weight,
        padding,
        hoverColor,
        hoverTextColor,
        selected,
      }}
      data-element={dataElement}
    >
      {label}
    </S.Button>
  );
};

export default Button;
